import { render, staticRenderFns } from "./PopProductDisplay.vue?vue&type=template&id=10067aea&scoped=true&lang=pug"
import script from "./PopProductDisplay.vue?vue&type=script&lang=js"
export * from "./PopProductDisplay.vue?vue&type=script&lang=js"
import style0 from "./PopProductDisplay.vue?vue&type=style&index=0&id=10067aea&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10067aea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10067aea')) {
      api.createRecord('10067aea', component.options)
    } else {
      api.reload('10067aea', component.options)
    }
    module.hot.accept("./PopProductDisplay.vue?vue&type=template&id=10067aea&scoped=true&lang=pug", function () {
      api.rerender('10067aea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/PopProductDisplay.vue"
export default component.exports